import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.define-property.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-undef */

/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Input, Button, Dropdown, showSuccess, DateTimePicker } from 'components/UI';
import { showApiError } from 'utils';
import { actionSearchTypesNameSelect } from 'enums';
import { createAction, updateAction } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ActionForm = function ActionForm(_ref) {
  var data = _ref.data,
      creditId = _ref.creditId,
      borrowerId = _ref.borrowerId,
      onSubmit = _ref.onSubmit,
      onClose = _ref.onClose;

  var initialFormData = _objectSpread({}, data);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var _values$note, _values$action, _values$follow_up_dat;

      var values, method, formData, params, _yield$method, _yield$method2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              values = _ref2.values;
              method = data ? updateAction : createAction;
              formData = _objectSpread(_objectSpread(_objectSpread({}, borrowerId && {
                borrower_id: borrowerId
              }), creditId && {
                credit_id: creditId
              }), {}, {
                note: (_values$note = values === null || values === void 0 ? void 0 : values.note) !== null && _values$note !== void 0 ? _values$note : data === null || data === void 0 ? void 0 : data.note,
                action: (_values$action = values === null || values === void 0 ? void 0 : values.action) !== null && _values$action !== void 0 ? _values$action : data === null || data === void 0 ? void 0 : data.action,
                follow_up_date: (_values$follow_up_dat = values === null || values === void 0 ? void 0 : values.follow_up_date) !== null && _values$follow_up_dat !== void 0 ? _values$follow_up_dat : data === null || data === void 0 ? void 0 : data.follow_up_date
              });
              params = data ? [data === null || data === void 0 ? void 0 : data.id, formData] : [formData];
              _context.next = 6;
              return method.apply(void 0, params);

            case 6:
              _yield$method = _context.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 12:
              showSuccess("\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u0442\u043E ".concat(data ? 'реадактиран' : 'създаден', " \u0443\u0441\u043F\u0435\u0448\u043D\u043E."));
              _isFunction(onSubmit) && onSubmit(res);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: initialFormData
  }, ___EmotionJSX(Row, null, ___EmotionJSX(Col, null, ___EmotionJSX(Dropdown, {
    noClear: true,
    required: true,
    formId: "action",
    label: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
    options: actionSearchTypesNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, null, ___EmotionJSX(DateTimePicker, {
    formId: "follow_up_date",
    label: "\u0414\u0430\u0442\u0430 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435",
    required: true,
    timeFormat: false,
    dateFormat: "YYYY-MM-DD"
  })), ___EmotionJSX(Col, null, ___EmotionJSX(Input, {
    formId: "note",
    type: "textarea",
    label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    required: true
  })), ___EmotionJSX(Col, {
    displayFlex: true,
    md: true,
    justify: "flex-end"
  }, function (_ref4) {
    var onSubmit = _ref4.onSubmit;
    return ___EmotionJSX(React.Fragment, null, _isFunction(onClose) && ___EmotionJSX(Button, {
      type: "secondary",
      onClick: onClose,
      margin: "0 1em 0 0"
    }, "\u041D\u0430\u0437\u0430\u0434"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0417\u0430\u043F\u0430\u0437\u0438"));
  })));
};

ActionForm.propTypes = {
  creditId: PropTypes.number,
  borrowerId: PropTypes.number,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  data: PropTypes.object
};
export default ActionForm;